import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid bg-white m-0" }, null, -1)
const _hoisted_2 = { class: "row p-4" }
const _hoisted_3 = {
  class: "col-12 col-lg-3",
  "data-aos": "fade-right",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_4 = {
  class: "col-12 col-lg-9 align-items-center center-highlight-item",
  "data-aos": "fade-up",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center my-2 me-4" }
const _hoisted_6 = { class: "text-start text-primary m-2" }
const _hoisted_7 = { class: "d-flex flex-wrap gap-4 m-2" }
const _hoisted_8 = {
  class: "text-decoration-none card border border-0",
  style: {"width":"18rem"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "card-body text-start" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "badge badge-primary bg-secondary ms-1 mb-2" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-facebook fs-4" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ms-2" }, null, -1)
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-line fs-4" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "ms-2" }, null, -1)
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-square-whatsapp fs-4" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "d-flex justify-content-end mx-5 my-2" }
const _hoisted_28 = { "aria-label": "Page navigation example" }
const _hoisted_29 = { class: "pagination" }
const _hoisted_30 = { class: "page-item" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "page-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryItem = _resolveComponent("CategoryItem")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CategoryItem)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.store.getters.localized('service')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: `/service/${item._id}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "img-fluid p-3 rounded",
                    src: _ctx.imageUrl(item.image),
                    alt: "Card image cap",
                    style: {"aspect-ratio":"1/1"}
                  }, null, 8, _hoisted_9)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.store.state.language==='th')
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_11, _toDisplayString(item.nameTH), 1))
                  : (_ctx.store.state.language==='ch')
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_12, _toDisplayString(item.nameCH), 1))
                    : (_openBlock(), _createElementBlock("h5", _hoisted_13, _toDisplayString(item.nameEN), 1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.languages, (lang) => {
                  return (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(lang), 1))
                }), 256)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `${item.facebook}`
                  }, _hoisted_18, 8, _hoisted_16),
                  _hoisted_19,
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `${item.line}`
                  }, _hoisted_22, 8, _hoisted_20),
                  _hoisted_23,
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `${item.wechat}`
                  }, _hoisted_26, 8, _hoisted_24)
                ])
              ])
            ]))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("nav", _hoisted_28, [
            _createElementVNode("ul", _hoisted_29, [
              _createElementVNode("li", _hoisted_30, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updatePaginate(_ctx.page-1)))
                }, "«")
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginate, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (index>_ctx.page-_ctx.limit&&index<_ctx.page+_ctx.limit)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: _normalizeClass(["page-item", {'active':(index==(_ctx.page-1))}])
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          href: "#",
                          onClick: ($event: any) => (_ctx.updatePaginate(index+1))
                        }, _toDisplayString(index+1), 9, _hoisted_31)
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256)),
              _createElementVNode("li", _hoisted_32, [
                (_ctx.page!=_ctx.pages)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "page-link",
                      href: "#",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updatePaginate(_ctx.page+1)))
                    }, " » "))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}